import { LocationTypeForSelect } from "../../Forms/LocationSelect/LocationTypeForSelect";

export enum LocationTypeForDestinationEnum {
  Plant = 1,
  EDC = 2,
  ODC = 3,
  EPC = 4,
}

const enum LocationTypeString {
  Plant = "Plant",
  EDC = "EDC",
  ODC = "ODC",
  EPC = "EPC",
}

export const locationTypesForDestination: LocationTypeForSelect[] = [
  { Id: LocationTypeForDestinationEnum.EDC, LocationType: LocationTypeString.EDC },
  { Id: LocationTypeForDestinationEnum.EPC, LocationType: LocationTypeString.EPC },
  { Id: LocationTypeForDestinationEnum.ODC, LocationType: LocationTypeString.ODC },
  { Id: LocationTypeForDestinationEnum.Plant, LocationType: LocationTypeString.Plant },
];

export const locationTypesAsString = new Map([
  [LocationTypeForDestinationEnum.EDC, LocationTypeString.EDC],
  [LocationTypeForDestinationEnum.EPC, LocationTypeString.EPC],
  [LocationTypeForDestinationEnum.ODC, LocationTypeString.ODC],
  [LocationTypeForDestinationEnum.Plant, LocationTypeString.Plant],
]);
